import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * Shared Page Header component for all standalone pages
 * Includes: Back button, Title, Language Switcher, Home button
 */
const PageHeader = ({ title, subtitle, showBackButton = true }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="bg-gradient-to-r from-[#2D0C4B] to-[#1A0730] text-white py-4 px-4 sm:px-6 shadow-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          {/* Left side - Back button and title */}
          <div className="flex items-center gap-4">
            {showBackButton && (
              <button
                onClick={() => navigate(-1)}
                className="p-2 hover:bg-white/10 rounded-full transition-colors"
                aria-label="Go back"
              >
                <ArrowLeft className="h-5 w-5" />
              </button>
            )}
            <div>
              <h1 className="text-xl sm:text-2xl font-bold">{title}</h1>
              {subtitle && (
                <p className="text-sm text-purple-200">{subtitle}</p>
              )}
            </div>
          </div>

          {/* Right side - Language Switcher and Home */}
          <div className="flex items-center gap-3">
            <LanguageSwitcher />
            <button
              onClick={() => navigate('/')}
              className="p-2 hover:bg-white/10 rounded-full transition-colors flex items-center gap-2"
              title={t('home') || 'Home'}
            >
              <Home className="h-5 w-5" />
              <span className="hidden sm:inline text-sm">{t('home') || 'Home'}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
